<template>
	<div class="_modal need-period-report-modal bg-white">
		<div
			class="_modal__content md-down:px-4 px-8 pt-8 pb-6 flex flex-col items-center"
		>
			<div
				class="w-full rounded-lg border border-neutral-100 overflow-hidden"
			>
				<div
					class="text-neutral-500 font-semibold text-xs px-4 py-3 border-b border-neutral-100"
				>
					Biểu đồ mối tương quan tuổi phát triển và tuổi thực của trẻ
					qua các lĩnh vực đã học
				</div>
				<img
					class="w-full h-auto pt-2"
					src="@/assets/images/illustrations/chart.png"
					alt=""
				/>
			</div>

			<div
				class="text-neutral-700 font-semibold text-2xl mt-4 text-center"
			>
				Có học sinh cần thực hiện Đánh giá phát triển
			</div>
			<div
				class="text-center text-neutral-500 mt-3 tracking-wide max-w-lg"
			>
				Các học sinh dưới đây đã hoàn thành số giờ can thiệp theo thiết
				lập của cơ sở và cần được Đánh giá phát triển để cập nhật tiến
				độ và điều chỉnh kế hoạch can thiệp.
			</div>

			<div
				v-if="visibleStudents.length"
				class="w-full grid grid-cols-2 gap-x-6 gap-y-3 mt-8"
			>
				<div
					v-for="student in visibleStudents"
					:key="student.id || student.name"
					class="text-orange-500 font-semibold"
				>
					<div class="flex items-center gap-2">
						<div class="relative flex-shrink-0 h-6 w-6">
							<img
								v-if="student?.profile_photo?.w200"
								:src="student?.profile_photo?.w200"
								alt=""
								class="shadow-sm block h-6 w-6 rounded-full object-cover"
							/>
							<span
								v-else
								:style="{
									background:
										student?.profile_photo?.default?.color,
								}"
								class="inline-flex items-center justify-center h-6 w-6 rounded-full flex-shrink-0"
							>
								<span
									class="font-medium leading-none text-white text-xs"
									>{{
										student?.profile_photo?.default?.initial
									}}</span
								>
							</span>
						</div>
						<div
							class="text-orange-600 hover:underline whitespace-nowrap"
						>
							<span class="font-semibold">{{
								student.name || student.full_name
							}}</span>
							<span class="text-neutral-700 font-normal"
								> ({{ student.lesson_report_count }}/{{
									student.no_hour_to_noti_periodic_assessment
								}}
								giờ)</span
							>
						</div>
					</div>
				</div>
			</div>
			<div
				v-if="remainingCount > 0"
				class="w-full text-left text-neutral-700 mt-3"
			>
				+ {{ remainingCount }} học sinh khác
			</div>
		</div>

		<div
			class="_modal__footer px-8 py-6 bg-neutral-50 flex flex-nowrap items-center"
		>
			<button
				type="button"
				class="button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700"
				@click="snoozeNeedGeneratePeriodReport"
			>
				Để sau
			</button>
			<button
				type="button"
				class="button-p text-center whitespace-nowrap"
				@click="submit"
			>
				Thực hiện đánh giá ngay
			</button>
		</div>
	</div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue';
import { $api } from '@/services';
import { useRouter } from 'vue-router';

const router = useRouter();
const props = defineProps({
	listStudents: {
		type: Array,
		default: () => [],
	},
});

const emit = defineEmits(['close']);

const visibleStudents = computed(() => {
	return props.listStudents.slice(0, 4);
});

const remainingCount = computed(() => {
	return props.listStudents.length - visibleStudents.value.length;
});

const snoozeNeedGeneratePeriodReport = async () => {
	try {
		await $api.org.snoozeNeedGeneratePeriodReport();
		emit('close');
	} catch (e) {
		console.log(e);
	}
};

const submit = () => {
	emit('close');
	router.push('/record/student');
};
</script>

<style scoped lang="scss">
.need-period-report-modal {
	width: 600px;
}
</style>
